<template>
    <div id="main-bar">
        <div class="inner">
            <Logo :vertical="true"/>
            <!--<span v-if="role">{{role}}</span>-->
            <div class="actions">
                <div><ProfileMenu /></div>
                <div><MenuToggle /></div>
            </div>
        </div>
        <div class="click-block" :class="{open: isOpen}" v-on:click="closeMenu();"></div>
    </div>
</template>

<script>
    import Logo from '../../core/Logo';
    import MenuToggle from './MenuToggle';
    import ProfileMenu from './ProfileMenu';

    export default {
        name: 'Header',
        computed: {
            isOpen() {
                return this.$store.state.menu.open;
            },
            role() {
                if(this.$store.state.user.profile) {
                    return this.$store.state.user.profile.roles[0];
                }
                return null;
            }
        },
        methods: {
            closeMenu() {
                this.$store.dispatch('toggleMenu');
            }
        },
        components: {MenuToggle, Logo, ProfileMenu}
    };
</script>

<style scoped>
    
    #main-bar {background: var(--colour-primary); width: 100%; box-sizing: border-box; padding: .15rem 1rem; height: 2.75rem; position: fixed; top: 0; z-index: 99;}
        #main-bar > .inner {display: flex; justify-content: space-between; height: 100%;}
        #main-bar > .inner .actions {}
        #main-bar > .inner .actions:before {content: ''; height: 100%; display: inline-block; vertical-align: middle;}
            #main-bar > .inner .actions > * {display: inline-block; vertical-align: middle;}
            #main-bar > .inner .actions > * + * {margin-left: 1rem;}
            #main-bar > .inner .actions > * >>> .avatar {font-size: 3px;}
    
    .click-block {display: none; position: fixed; top: 2.75rem; right: 0; bottom: 0; left: 0; z-index: 999;}
        .click-block.open {display: block;}
    
</style>